import React, { FunctionComponent, } from 'react';
import './AppLayout.css'
Wizard

import {
  AppBar,
  IconButton,
  Grid,
  Toolbar,
  Typography,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Wizard from '../../components/Wizard/Wizard';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { originCleared } from '../../App/app';

interface Props {
  title: string,
  onBack?: () => void,
}

const AppLayout: FunctionComponent<Props> = ( props ) => {

  const origin = useSelector( ( state: RootState ) => state.app.searchParameters.origin );
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const onBack = () => {
    dispatch( originCleared() );
  }

  return (
    <div className="layout app-layout">
      <Wizard
        origin={ origin }
        onBack={ onBack }
      ></Wizard>
       <AppBar position="static">
            <Toolbar>
            { props.onBack && (
                <IconButton
                  aria-label={ t( 'back' ) }
                  sx={ { color: 'white' } }
                  onClick={ props.onBack }
                ><ArrowBack /></IconButton>
            ) }
            <Typography variant="h6" component="div">
              { t( props.title ) }
            </Typography>
          </Toolbar>
      </AppBar>
      <main>
        { props.children }
      </main>
    </div>
  );
}

export default AppLayout;
